export const HOTELS_IMPORTS_ENDPOINT_KEY = 'hotels-imports'
